var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex p-5 items-center align-items-center"},[_c('h6',{staticClass:"text-white mb-0"},[_vm._v("Notes")])])
}]

export { render, staticRenderFns }